export default __webpack_public_path__ + "static/media/moreIcon.394ddcb0.svg";